import { activeSeasonalThemeAtom } from "@/atoms/seasonal-theme"
import type { SeasonalEffects, SeasonalView } from "@/domain/seasonal"
import { useAtomValue } from "jotai"

/** The active seasonal theme's effects for `view`, or undefined when none applies. */
export function useSeasonalEffects<V extends SeasonalView>(view: V): SeasonalEffects[V] | undefined {
  return useAtomValue(activeSeasonalThemeAtom)?.effects[view]
}
